import type { FeatureFlag } from "./featureFlags";
import { isFeatureEnabled } from "./featureFlags";

export const useFeatureFlag = (flag: FeatureFlag): boolean => isFeatureEnabled(flag);
